import { memo, useEffect, useRef, useState } from "react";
import { Modal } from "antd";
import Cropper from "cropperjs";
import "./ImageCropper.scss";
import "cropperjs/dist/cropper.css";
import { IMAGE_MIME_TYPES } from "../../constants";

export interface ImgCropperType {}

export interface ImageCropperProps {
    simpleCropper: {
        croppeAspectRatio: number;
        base64: string;
    };
    onClose: (x?: any) => void;
}

const ImageSimpleCropper = memo(
    ({ simpleCropper, onClose }: ImageCropperProps) => {
        const imgRef = useRef<HTMLImageElement>(null);
        const [cropper, setCropper] = useState<Cropper>();

        const handleOk = () => {
            cropper!.crop();
            const croppedCanvas = cropper!.getCroppedCanvas();

            croppedCanvas.toBlob((blob) => {
                if (!blob) {
                    return;
                }
                const file = new File([blob], "background.png", {
                    type: IMAGE_MIME_TYPES.png,
                });

                onClose(file);
            });
        };

        const handleCancel = () => {
            onClose();
        };

        useEffect(() => {
            const cropper = new Cropper(imgRef.current!, {
                autoCropArea: 1,
                aspectRatio: simpleCropper.croppeAspectRatio,
                ready() {
                    setCropper(cropper);
                },
            });

            return () => {
                cropper!.destroy();
            };
        }, []);

        return (
            <div className="image-cropper">
                <Modal
                    width={550}
                    centered
                    getContainer={false}
                    open
                    onOk={handleOk}
                    onCancel={handleCancel}
                >
                    <div className="img-container">
                        <img ref={imgRef} src={simpleCropper.base64} alt="img" />
                    </div>
                </Modal>
            </div>
        );
    },
);

export default ImageSimpleCropper;
